import React from 'react';

import { hiddenByGender } from '@libs/NwFeatures';

import FeatureValueField from '@components/Features/FeatureValueField';

// const FULL_WIDTH_FEATURE_TYPES = ['Multichoice', 'BigText', 'Text', 'Conversion'];

const PUBLIC_VALUE_FIELD_SUFFIX = '__PublicValue';

const getFeatureFormColSpan = () => {
    // if (breakpoints === 1 || FULL_WIDTH_FEATURE_TYPES.includes(featureTypeName)) {
    //     return 24;
    // }
    // return 12;
    return 24;
};

const getPublicValueFieldID = (fieldID) => `${fieldID}${PUBLIC_VALUE_FIELD_SUFFIX}`;

const isPublicValueFieldID = (fieldID) => fieldID && fieldID.endsWith(PUBLIC_VALUE_FIELD_SUFFIX);

const getRealValueFieldID = (fieldID) => {
    if (!isPublicValueFieldID(fieldID)) {
        return fieldID;
    }
    return fieldID.replace(PUBLIC_VALUE_FIELD_SUFFIX, '');
};

const hasFeatureValue = (value) => value !== null && value !== undefined && value !== '';

// stesso gate usato in lettura da getPublicFeatureForDisplay: conta solo il valore pubblico
const hasPublicFeatureValue = (contactFeature) => contactFeature && hasFeatureValue(contactFeature.PublicValue);

const getActivePublicFieldIDs = (groupFeatures, contactFeatures) => {
    return groupFeatures.reduce((fieldIDs, feature) => {
        const contactFeature =
            contactFeatures && contactFeatures.find((contactFeature) => contactFeature.FeatureID === feature.FeatureID);
        if (hasPublicFeatureValue(contactFeature)) {
            fieldIDs.push(getPublicValueFieldID(feature.ID));
        }
        return fieldIDs;
    }, []);
};

const getFeatureInitialValues = (groupFeatures, contactFeatures) => {
    const initialValues = {};

    groupFeatures.forEach((feature) => {
        const contactFeature =
            contactFeatures && contactFeatures.find((contactFeature) => contactFeature.FeatureID === feature.FeatureID);
        initialValues[feature.ID] = contactFeature && contactFeature.Value;
        initialValues[getPublicValueFieldID(feature.ID)] = hasPublicFeatureValue(contactFeature)
            ? contactFeature.PublicValue
            : null;
    });

    return initialValues;
};

const getVisibleGroupFeatures = (featuresGroup, globalFeatures, globalConversions, contact) => {
    let groupFeatures = featuresGroup.GroupFeatures.map((groupFeature) => {
        let feature = globalFeatures && globalFeatures.find((feature) => feature.ID === groupFeature.FeatureID);
        if (feature && feature.TypeName === 'Conversion') {
            feature = {
                ...feature,
                conversion:
                    globalConversions && globalConversions.find((conversion) => conversion.ID === feature.ConversionID),
            };
        }
        return {
            ...groupFeature,
            Feature: feature,
        };
    });

    // una feature del gruppo può non essere più fra quelle globali (disattivata, cancellata):
    // senza nome né tipo non c'è niente da disegnare, e ogni accesso a Feature esploderebbe
    return groupFeatures.filter(
        (groupFeature) => groupFeature.Feature && !hiddenByGender(groupFeature.Feature, contact)
    );
};

const getPublicValueItem = (item, publicValueFieldID) => {
    return {
        ...item,
        ID: publicValueFieldID,
        itemid: publicValueFieldID,
        Feature: {
            ...item.Feature,
            Name: `${item.Feature.Name} Public`,
        },
    };
};

function createFeatureItemForm(
    item,
    value,
    globalConversions,
    setFieldValue,
    featuresIndex,
    onUpdateFeature,
    disabled,
    setUpdatedFieldIDs,
    setCurrentUpdatingFieldID,
    gender,
    addOnBefore
) {
    return (
        <FeatureValueField
            item={item}
            value={value}
            setFieldValue={setFieldValue}
            featuresIndex={featuresIndex}
            onUpdateFeature={onUpdateFeature}
            disabled={disabled}
            setUpdatedFieldIDs={setUpdatedFieldIDs}
            setCurrentUpdatingFieldID={setCurrentUpdatingFieldID}
            gender={gender}
            addOnBefore={addOnBefore}
        />
    );
}

export {
    createFeatureItemForm,
    getActivePublicFieldIDs,
    getFeatureInitialValues,
    getFeatureFormColSpan,
    getPublicValueFieldID,
    getPublicValueItem,
    getRealValueFieldID,
    getVisibleGroupFeatures,
    hasFeatureValue,
    hasPublicFeatureValue,
};
